"use client";

export const Button = ({
  name,
  type = "button",
  func,
  text,
  children,
  className,
  extraClass,
  disabled,
  ...rest
}) => {
  const extra_class = extraClass ? extraClass : "pt-[.56rem] pb-[.56rem]";
  const names = {
    light_blue_btn: `${extra_class} text-base bg-white btnLspace text-mainLightPurple border border-mainLightPurple font-bold text-center rounded-[8px] w-full`,
    main_btn: `${extra_class} text-white bg-purpleGradient text-center px-6 rounded-[8px] btnLspace w-full font-bold`,
    // apply_btn: `${extra_class} text-white bg-main text-center rounded-[8px] btnLspace w-full font-semibold`,
    blue_bordered_btn: `${extra_class} whitespace-nowrap h-12 border-2 rounded-lg px-8  border-mainLightPurple text-mainLightPurple bg-white hover:bg-mainLightPurple hover:text-white transition-all duration-300 font-semibold`,
    green_btn: `whitespace-nowrap h-12 rounded-lg px-8 bg-main font-semibold`,
    green_bordered_btn: `whitespace-nowrap h-12 rounded-lg px-8 border-2 border-main text-main font-semibold`,
  };
  const classes = className ? className : names[name];
  const btn_text = children?.length > 0 ? children : text;

  return (
    <button
      type={type}
      className={`${classes} font-manrope ${disabled ? "opacity-30" : "opacity-100"}`}
      onClick={func}
      {...rest}
      disabled={disabled}
    >
      {btn_text}
    </button>
  );
};

export const PanelButton = ({ text, func }) => {
  return (
    <button
      onClick={func}
      className="text-mainLightPurpleText text-base leading-[24px] px-4 py-3 bg-mainBgPurple border border-mainLightPurple rounded-lg"
    >
      {text}
    </button>
  );
};
